(() => {
  const PRICE_BY_PACK = {
    0: '$0',
    1: '$5',
    2: '$9',
    3: '$12',
    4: '$15',
    5: '$18',
  };

  const propertyName = (name) => name.slice(11, -1);

  const currentProperties = () => {
    const properties = {};

    document.querySelectorAll('[name^="properties["]').forEach((field) => {
      if (field.disabled || ((field.type === 'checkbox' || field.type === 'radio') && !field.checked)) return;
      const key = propertyName(field.name);
      if (key && field.value !== '') properties[key] = field.value;
    });

    return properties;
  };

  const initialize = (root) => {
    const variantData = root.querySelector('[data-holland-variants]');
    const submit = root.querySelector('[data-holland-submit]');
    const message = root.querySelector('[data-holland-message]');
    const acknowledgement = root.querySelector('[data-holland-acknowledgement]');
    if (!variantData || !submit || !message || !acknowledgement) return;

    const variants = JSON.parse(variantData.textContent);
    const variantFor = (artwork, pack) =>
      variants.find((variant) => variant.artwork === artwork && variant.pack === String(pack));

    const selectedPack = (key) =>
      root.querySelector(`[data-holland-quantity-group="${key}"] input:checked`)?.value || '0';

    const updatePanel = (key) => {
      const pack = selectedPack(key);
      const output = root.querySelector(`[data-holland-price="${key}"]`);
      if (output) output.textContent = PRICE_BY_PACK[pack] || '$0';
      message.textContent = '';
    };

    root.querySelectorAll('[data-holland-quantity]').forEach((input) => {
      input.addEventListener('change', () => updatePanel(input.closest('[data-holland-quantity-group]').dataset.hollandQuantityGroup));
    });
    acknowledgement.addEventListener('change', () => {
      message.textContent = '';
    });

    submit.addEventListener('click', async () => {
      const originalPack = selectedPack('original');
      const updatedPack = selectedPack('updated');
      const selections = [
        ['Original Patch Artwork', originalPack],
        ['Updated Digital Artwork', updatedPack],
      ].filter(([, pack]) => pack !== '0');

      if (selections.length === 0) {
        message.textContent = 'Please choose at least one decal.';
        return;
      }

      if (!acknowledgement.checked) {
        message.textContent = 'Please confirm that you understand you are ordering a sticker, not a patch.';
        acknowledgement.focus();
        return;
      }

      const properties = currentProperties();
      const items = selections.map(([artwork, pack]) => {
        const variant = variantFor(artwork, pack);
        if (!variant || !variant.available) throw new Error(`${artwork} pack ${pack} is unavailable.`);
        return { id: variant.id, quantity: 1, properties };
      });

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      message.textContent = 'Adding selected decals…';

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'The selected decals could not be added.');
        }
        window.location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        message.textContent = error.message || 'The selected decals could not be added.';
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    });
  };

  document.querySelectorAll('[data-holland-two-panel]').forEach(initialize);
})();
